import { AuthenticatedVehicleGroupDto } from "@/shared/api-contract/api-contract";
import { shallowRef } from "vue";

export enum OtherDealsPopupCustomerAction {
    buy = "buy",
    like = "like",
}

type Car = AuthenticatedVehicleGroupDto;
export class OtherDealsPopupModel {
    show = shallowRef(false);
    cars = shallowRef<readonly AuthenticatedVehicleGroupDto[]>([]);
    customerAction = shallowRef<OtherDealsPopupCustomerAction>(
        OtherDealsPopupCustomerAction.buy,
    );

    showPopup(
        customerAction: OtherDealsPopupCustomerAction,
        cars: readonly AuthenticatedVehicleGroupDto[],
    ) {
        this.show.value = true;
        this.customerAction.value = customerAction;
        this.cars.value = cars;
    }
}

export const otherDealsPopupModel = new OtherDealsPopupModel();
